import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ReactCodeInput from "react-verification-code-input";
import { Space, Typography } from "antd";
import { LogoIcon } from "assets/icons";
import {
  STORAGE_KEYS,
  TWO_FACTOR_AUTH,
  USER_TYPE,
} from "constants/appConstant";
import {
  AuthInfo,
  doRequestTwoFactorAuth,
  doVerifyTwoFactorAuth,
  getEmail,
  getMe,
  getTwoFactorAuthRes,
} from "stores/slices/auth";
// import { requestForToken } from "useFirebase/firebase";
import StorageHelper from "utils/storeHelper";

import AppButton from "components/button";

import styles from "../styles.module.scss";
const TwoFactorAuthenticationPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const twoFactorAuthRes = useSelector(getTwoFactorAuthRes);
  const authInfo = useSelector(AuthInfo);
  const email = useSelector(getEmail);
  const authToken = StorageHelper.getCookie(STORAGE_KEYS.verifyToken);

  const handleVerifyTwoFactorAuth = async data => {
    if (data) {
      // Notification.requestPermission().then(permission => {
      //   if (permission === "granted") {
      //     requestForToken().then(token => {
      //       if (token) {
      //       } else {
      //         const request = {
      //           id: authToken,
      //           verifiedCode: data,
      //         };
      //         const { payload } = await dispatch(doVerifyTwoFactorAuth(request));
      //         if (payload && payload.status === 200) {
      //           StorageHelper.setCookie(
      //             STORAGE_KEYS.token,
      //             twoFactorAuthRes.authToken,
      //             {
      //               maxAge: twoFactorAuthRes.expireTime,
      //             }
      //           );
      //           await dispatch(getMe());

      //           if (
      //             authInfo.type === USER_TYPE.USER &&
      //             authInfo.workspaceRole === USER_TYPE.USER &&
      //             authInfo.workspaceId
      //           ) {
      //             navigate("/inbox/messages");
      //           } else {
      //             navigate("/admin/dashboard");
      //           }
      //         }
      //       }
      //     });
      //   }
      // });
      const request = {
        id: authToken,
        verifiedCode: data,
      };
      const { payload } = await dispatch(doVerifyTwoFactorAuth(request));
      if (payload && payload.status === 200) {
        StorageHelper.setCookie(
          STORAGE_KEYS.token,
          twoFactorAuthRes.authToken,
          {
            maxAge: twoFactorAuthRes.expireTime,
          }
        );
        await dispatch(getMe());

        if (
          authInfo.type === USER_TYPE.USER &&
          authInfo.workspaceRole === USER_TYPE.USER &&
          authInfo.workspaceId
        ) {
          navigate("/inbox/messages");
        } else {
          navigate("/admin/dashboard");
        }
      }
    }
  };

  const handleRequestTwoFactorAuthCode = async () => {
    const request = {
      id: authToken,
    };
    await dispatch(doRequestTwoFactorAuth(request));
  };

  const handleBackToSignIn = () => {
    if (authToken) {
      StorageHelper.removeCookie(STORAGE_KEYS.verifyToken);
      navigate("/auth/sign-in");
    }
  };

  return (
    <div className={styles.twoFactorAuthContainer}>
      <div className={styles.twoFactorAuthRow}>
        <div className="authLogo">
          <LogoIcon />
        </div>
        <Typography className={styles.twoFactorAuthTitle}>
          {t("twoFactorAuth.twoFactorAuthTitle")}
        </Typography>

        {twoFactorAuthRes?.twoFactorAuth === TWO_FACTOR_AUTH.GOOGLE_AUTH && (
          <>
            <div
              className={styles.twoFactorAuthMsg}
              dangerouslySetInnerHTML={{
                __html: t("twoFactorAuth.twoFactorAuthMsg"),
              }}
            />
          </>
        )}
        {twoFactorAuthRes?.twoFactorAuth === TWO_FACTOR_AUTH.EMAIL && (
          <>
            <div
              className={styles.twoFactorAuthMsg}
              dangerouslySetInnerHTML={{
                __html: t("twoFactorAuth.twoFactorAuthEmailMsg", {
                  email: email,
                }),
              }}
            />
          </>
        )}
        <ReactCodeInput
          type={"number"}
          onComplete={val => handleVerifyTwoFactorAuth(val)}
          className="twoFactorAuthInput"
        />
        <div className={styles.twoFactorAuthFooter}>
          {twoFactorAuthRes?.twoFactorAuth === TWO_FACTOR_AUTH.GOOGLE_AUTH && (
            <AppButton
              label={t("twoFactorAuth.backToQRCode")}
              color={"primary"}
              type="submit"
              onClick={() => navigate("/auth/request-qr-code")}
              className="twoFactorAuthBtn"
            />
          )}
          {twoFactorAuthRes?.twoFactorAuth !== TWO_FACTOR_AUTH.GOOGLE_AUTH && (
            <AppButton
              label={t("twoFactorAuth.resendCode")}
              color={"primary"}
              // loading={loading}
              type="submit"
              onClick={handleRequestTwoFactorAuthCode}
              className="twoFactorAuthBtn"
            />
          )}
        </div>
        <Space
          direction="horizontal"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>{`${t("label.signInMessage")} `}</span>
          <Link
            onClick={handleBackToSignIn}
            style={{
              fontWeight: 700,
            }}
          >
            {t("label.signIn")}
          </Link>
        </Space>
      </div>
    </div>
  );
};
export default TwoFactorAuthenticationPage;
